import CentricDispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import EventEmitter from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

let _courseEnrolments = [];
let _isFetching = 0;
let _fetchedAll = false;

const sanitise = ({id, courseId, userId, userDeleted, ...rest}) => ({
    id: Number(id),
    courseId: Number(courseId),
    userId: Number(userId),
    userDeleted: !!Number(userDeleted),
    ...rest,
});

let CourseEnrolmentStore = assign({}, EventEmitter.prototype, {

    emitChange: function() {
        this.emit(CHANGE_EVENT);
    },
    addListener: function(callback) {
        this.addChangeListener(callback);
        return { remove: () => this.removeChangeListener(callback) };
    },
    addChangeListener: function(callback) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener: function(callback) {
        this.removeListener(CHANGE_EVENT, callback);
    },
    getAll: function() {
        return _courseEnrolments.filter(function(e) { return e !== undefined; });
    },

    get: function(courseId, userId) {
        return _courseEnrolments.find(function(e) { return e !== undefined && e.courseId == courseId && e.userId == userId; });
    },
    getById: function(id) {
        return _courseEnrolments.find(function(e) { return e !== undefined && e.id == id; });
    },
    getByCourse: (courseId) => _courseEnrolments.filter(e => !!e && e.courseId === courseId),
    getByUser: function(userId) {
        return _courseEnrolments.filter(function(e) { return e !== undefined && e.userId == userId; });
    },


    add: function(data) {
        data = sanitise(data);
        if (!data.userId || !data.courseId) { return false; }

        const enrolmentIndex = _courseEnrolments.findIndex( (e) => !!e && e.userId === data.userId && e.courseId === data.courseId);
        if (enrolmentIndex < 0) {
            _courseEnrolments = [ ..._courseEnrolments, data];
        } else {
            _courseEnrolments = _courseEnrolments.map((e, i) => i === enrolmentIndex ? data : e);
        }
    },

    setLoading: (enrolmentId, loading = true) => {
        const index = _courseEnrolments.findIndex((e) => (!!e && e.id === enrolmentId));
        if (0 <= index) {
            _courseEnrolments = _courseEnrolments.map((e, i) => i !== index ? e : {...e, loading});
        }
    },

    remove: function(enrolmentId) {
        _courseEnrolments = _courseEnrolments.filter(e => !!e && e.id !== enrolmentId);
    },

    isFetching: () => (_isFetching > 0),
    setFetching: (isFetching = true) => (_isFetching += (isFetching ? +1 : -1)),
    fetchedAll: () => (_fetchedAll)
});

CourseEnrolmentStore.dispatchToken = CentricDispatcher.register(function(action) {

    switch(action.type) {

        case ActionTypes.COURSE_ENROLMENT_LIST:
            if (action.data.length === 0) {
                _fetchedAll = true;
            } else if (!!action.payload.clearAll) {
                _courseEnrolments = action.data.map(sanitise);
            } else {
                action.data.forEach(CourseEnrolmentStore.add);
            }
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_INFO_REQUEST:
            CourseEnrolmentStore.setFetching(true);
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_INFO_SUCCESS:
            CourseEnrolmentStore.setFetching(false);
            CourseEnrolmentStore.add(action.data);
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_INFO_FAILURE:
            CourseEnrolmentStore.setFetching(false);
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_UPDATE_SUCCESS:
            CourseEnrolmentStore.add(action.data);
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_BULK_UPDATE_SUCCESS:
            if (!action.data.backgroundTask) {
                action.data.results.forEach(CourseEnrolmentStore.add);
                CourseEnrolmentStore.emitChange();
            }
            break;

        case ActionTypes.COURSE_ENROLMENT_DELETE_REQUEST:
            CourseEnrolmentStore.setLoading(action.payload.enrolment.id);
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_DELETE_SUCCESS:
            CourseEnrolmentStore.remove(action.payload.enrolment.id);
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_DELETE_FAILURE:
            CourseEnrolmentStore.setLoading(action.payload.enrolment.id, false);
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_BULK_DELETE_SUCCESS:
            if (!action.data.backgroundTask) {
                action.data.results.forEach((ce) => {
                    if (!!ce.deleted) {
                        CourseEnrolmentStore.remove(ce.id);
                    }
                });
                CourseEnrolmentStore.emitChange();
            }
            break;

        case ActionTypes.USER_COURSE_ENROL:
            CourseEnrolmentStore.add(action.data);
            CourseEnrolmentStore.emitChange();
            break;

        case ActionTypes.COURSE_ENROLMENT_BY_FILTER_SAVE_SUCCESS:
            if (!action.data.backgroundTask) {
                action.data.results.forEach(CourseEnrolmentStore.add);
                CourseEnrolmentStore.emitChange();
            }
            break;

        case ActionTypes.COURSE_ENROLMENT_CHECK_COMPLETE_SUCCESS:
            CourseEnrolmentStore.add(action.data);
            CourseEnrolmentStore.emitChange();
            break;

        default:
            break;
    }

});

export default CourseEnrolmentStore;
